import React from "react";
import { useSelector, useDispatch, batch } from "react-redux";
import get from "lodash/get";
import { Share } from "../molecules/share/index.js";
import { SvgHandler } from "../svg-handler/svg-handler";
import close from "../../../assets/icons/social/close.svg";
import { DEFAULT_AMAZON_POLLY_CAPTION } from "../../constants";

import "./amazon-polly.m.css";

export const AmazonPollyPopup = () => {
  const dispatch = useDispatch();
  const config = useSelector(state => get(state, ["qt", "config"], {}));
  const amazonPolly = useSelector(state => get(state, ["amazonPolly"]));
  const { storyData, isOpen } = amazonPolly;
  const caption = get(storyData, ["headline"], DEFAULT_AMAZON_POLLY_CAPTION);
  const audioS3Key = get(storyData, ["story-audio", "s3-key"], "");
  const cdn = get(config, ["cdn-image"]);
  const audioSrc = `//${cdn}/${audioS3Key}`;
  const audioAttributes = { controls: true, autoPlay: true, preload: "metadata", controlsList: "nodownload" };

  const closeHandler = () => {
    batch(() => {
      dispatch({ type: "CLOSE_AMAZON_POLLY" });
      dispatch({ type: "SHOW_METERING_INDICATOR" });
    });
  };

  return (
    isOpen && (
      <div styleName="amazon-polly-bar-wrapper">
        <figure styleName="amazon-polly-content">
          <figcaption styleName="amazon-polly-caption">{caption}</figcaption>
          <div data-testid="amazon-polly-audio-wrapper" styleName="amazon-polly-audio-wrapper">
            <audio styleName="amazon-polly-audio" src={audioSrc} {...audioAttributes}>
              Your browser does not support the <code>audio</code> element.
            </audio>
            <div styleName="social-share-wrapper">
              <Share story={storyData} config={config} grey={true} vertical={true} overrideStyles={true} />
            </div>
          </div>
        </figure>
        <div styleName="amazon-polly-close-wrapper" onClick={closeHandler}>
          <SvgHandler width="24px" height="24px" xlinkHref={close} clazzName="amazon-polly-close" />
        </div>
      </div>
    )
  );
};
